exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.usage_heading_1[data-v-7acb2df0] { width: 100%;\n}\n", "", {"version":3,"sources":["/var/www/mentoring/vuejs-mentoring/src/components/admin/src/components/admin/enterprise_lookup_usage_tab.vue"],"names":[],"mappings":";AAUA,oCAAA,YAAA;CAAA","file":"enterprise_lookup_usage_tab.vue","sourcesContent":["<template>\n    <div class=\"col-12\">\n        <div class=\"search-padd\">\n            <div class=\"col-xs-12 override-padding\">\n                <div class=\"crm_admin_heading usage_heading_1\"></div>\n            </div>\n        </div>\n    </div>\n</template>\n<style scoped>\n.usage_heading_1 { width: 100%; }\n</style>"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7acb2df0","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/admin/enterprise_lookup_usage_tab.vue
// module id = JJRk
// module chunks = 0